import { app, store } from "../index";
import { datapop } from "../actions/data-populate";
import { modalhandler } from "../actions/modal-handler";
import {
  RealTimeGrabRedux,
  RealTimeGetRedux,
  RealTimeFindRedux,
  realtimefindreduxobject
} from "./realtimeservice";
import { getservice, grabserviceredux } from "./crudservice";
import moment from "moment";

export function LoginService(userid) {
  // let test_user_id = userid.replace(/^\D+/g, "");
  grabserviceredux("edfemployees", "employees").then(emps => {
    // console.log("login_emps", emps);
    let me = emps.find(e => e.userid === userid);
    getservice("edfemployees", me.empnumber)
      .then(response => {
        // response = response[0];
        store.dispatch({
          type: "RealTimeUpdate for myrealtimeinfo",
          payload: response
        });
        store.dispatch(modalhandler("none"));
        let data = response;
        let empnumint = parseInt(data.empnumber);
        // console.log("got myinfo");

        RealTimeFindRedux("assign", "removed", 0, "assignedjobs");

        let msgquery = {
          $or: [{ fromemp: data.empnumber }, { toemp: data.empnumber }],
          $sort: { id: -1 }
        };
        realtimefindreduxobject("messages", msgquery, "message-reducer");
        //  RealTimeGetRedux("edfemployees", data.empnumber, "myrealtimeinfo");
        getcustomers(data.hradmin);
      })
      .catch(err => console.log("error logging in", err));
    RealTimeGrabRedux("workorders", "workorders");
  });
}

const getcustomers = adminstatus => {
  console.log("Admin Status is " + adminstatus);
  grabserviceredux("customers", "custreducer");
  grabserviceredux("billing", "custreducer");
  grabserviceredux("location", "custreducer");
  grabserviceredux("engassigned", "custreducer");
  grabserviceredux("salarycodes", "custreducer");
  grabserviceredux("programs", "custreducer");
};

const realtime = () => {
  var weekarray = [];
  let monday = moment()
    .startOf("isoWeek")
    .format("YYYY-MM-DD");
  for (var i = 0; i < 7; i++) {
    let date = moment(monday)
      .add(i, "days")
      .format("YYYY-MM-DD");

    weekarray.push(date);
  }
  store.dispatch(datapop(weekarray, "Found This Week"));
};
// const assignjobs = empNumber => {
//   console.log(empNumber);
//
//   const jobassign = app.service("assign");
//
//   var assignedjobs = jobassign
//     .watch()
//     .find(
//       {
//         query: {
//           empnumber: empNumber
//         }
//       },
//       { rx: { listStrategy: "always" } }
//     )
//     .subscribe(jobs => {
//       console.log(jobs);
//       store.dispatch(rtupdate(jobs, "assignedjobs"));
//     });
// };

export const LogoutService = () => {
  window.localStorage.setItem("token", null);
  window.location.reload();
};



// WEBPACK FOOTER //
// ./src/services/loginservice.js